import { downloadFile } from './downloadFile';

/**
 * Captures the current contents of the given WebGL canvas as a PNG.
 *
 * IMPORTANT: the canvas must have been created/rendered with
 * `preserveDrawingBuffer: true` (see Viewer3D.tsx), otherwise the buffer may
 * already be cleared by the time `toBlob` runs.
 */
export function exportThumbnail(canvas: HTMLCanvasElement, fileName: string): Promise<void> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error('Failed to capture thumbnail from the 3D viewport.'));
        return;
      }
      downloadFile(blob, fileName, 'image/png');
      resolve();
    }, 'image/png');
  });
}
